import type {
  GlucosePercentageDistributionInsight,
  InsightKey,
} from "@tandemdiabetes/sugarmate-api-react-client"
import classNames from "classnames"
import { useCalculationsContext } from "../CalculationsContext"
import styles from "./DistributionPercentages.module.scss"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { round } from "src/utils"

interface ValueProps {
  insightKey: InsightKey;
  percentage: number;
}

function DistributionPercentageValue(props: ValueProps) {
  const {
    insightKey,
    percentage,
  } = props

  const value = isNaN(percentage) ? "--" : round(percentage * 100)

  return (
    <div
      className={styles.distributionPercentageValue}
      id={`${insightKey}-value`}
    >
      {value}
      <span
        className={styles.distributionPercentageSymbol}
        id={`${insightKey}-percent`}
      >
        %
      </span>
    </div>
  )
}


export function GlucosePercentageDistribution(props: TileProps<GlucosePercentageDistributionInsight>) {
  const {
    insightKey,
    range,
  } = props

  const { glucoseCalculations } = useCalculationsContext()
  const {
    percentAboveNormal,
    percentBelowNormal,
    percentWithinNormal,
  } = glucoseCalculations[range] || {}

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <div className={styles.distributionPercentages}>
        <div className={styles.distributionPercentage}>
          <DistributionPercentageValue
            insightKey={insightKey}
            percentage={percentBelowNormal}
          />
        </div>
        <div
          className={classNames(
            styles.distributionPercentage,
            styles.distributionWithinNormal,
          )}
        >
          <DistributionPercentageValue
            insightKey={insightKey}
            percentage={percentWithinNormal}
          />
        </div>
        <div className={styles.distributionPercentage}>
          <DistributionPercentageValue
            insightKey={insightKey}
            percentage={percentAboveNormal}
          />
        </div>
      </div>
    </>
  )
}
